import React, { useState, useEffect} from 'react';
import language from '../../../utils/LanguageSettings';
import { fetchSupport } from '../../functions/fetchSupport';
import '../../../css/support.css'
import { SOURCE_URL } from '../../../config';
import RenderSnA from '../../functions/renderSnA';
import SupportSearchSuggestion from './SupportSearchSuggestion';

interface SupportProps {

}

const Support: React.FC<SupportProps> = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [supportData, setSupportData] = useState<any>();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
    const [isSearch, setIsSearch] = useState<boolean>(false);
    const [keyword, setKeyword] = useState("");
    const [activeItemIndex, setActiveItemIndex] = useState(null);
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            let data = await fetchSupport(language);
            if(data){
                setSupportData(data?.data?.attributes);
                setLoading(false);
                setGa(data?.data?.attributes?.GA || null);
                setSeo(data?.data?.attributes?.SEO || null);
            }
        };
        fetchData();
    }, [language]);

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 767);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    const handleTopic = (topicData: any) => {
        if(topicData){
            return Array.isArray(topicData) && topicData.map((item, index) => (
                <div className="col-lg-2-5 col-md-4" key={index}>
                    <a className="box px-2 d-flex lg_font_size" href={window.location.origin + "/support/" + item?.attributes?.slug}>{item?.attributes?.Name}</a>
                </div>
            ));
        }
    }

    const handleCommonSolutionsWithImage = (image: any) => {
        if(image){
            return Array.isArray(image) && image.map((item, index) => (
                <div className="col-md-4 col-sm-6 box-wrap" key={index}>
                    <a className="box d-block h-100" href={window.location.origin +"/support/"+ item?.attributes?.slug}>
                        <div className="img-wrapper">
                            <img className="img-fluid d-block mx-auto ls-is-cached lazyloaded" src={`${SOURCE_URL}` +item?.attributes?.FeaturedImage?.data?.attributes?.url} />
                            <noscript><img src={`${SOURCE_URL}` +item?.attributes?.FeaturedImage?.data?.attributes?.url} className="img-fluid d-block mx-auto" /></noscript>
                        </div>
                        <h5 className="font-medium d-block p-3">{item?.attributes?.Name}</h5>
                    </a>
                </div>
            ));
        }
    }

    const handleCommonSolutionsWithDiscription = (description: any) => {
        if(description){
            return Array.isArray(description) && description.map((item, index) => (
                <div className="col-md-4 col-sm-6 box-wrap with-desc" key={index}>
                    <a className="box d-block h-100 p-3 position-relative with-desc" href={window.location.origin + "/support/" + item?.attributes?.slug}>
                        <h5 className="font-medium d-block pb-3">{item?.attributes?.Name}</h5>
                        <p className="barlow-font sm_font_size pb-4 mb-3">{item?.attributes?.description}</p>
                        <span className="color-1 barlow-font d-block arrowed-link">{supportData?.link_text}<i className="icon-angle-right"></i></span>
                    </a>
                </div>
            ));
        }
    }

    const handleFaq = (FaqData: any) => {
        if(FaqData){
            return Array.isArray(FaqData) && FaqData.map((item, index) => (
                <div className="col-lg-4 col-md-6 mb-md-5 mb-0" key={index}>
                    <h5 className={activeItemIndex === index ? 'cat-group font-medium pb-2 mb-4 active' : 'cat-group font-medium pb-2 mb-4'}
                        onClick={() => handleClick(index)}
                        style={{ cursor: isMobile ? 'pointer' : 'default' }}>
                            {item?.ColumnTitle}
                    </h5>
                    <ul className="barlow-font light-gray" style={{ display: activeItemIndex === index ? 'block' : 'none' }}>
                        {handleSupportArticle(item?.SupportArticles?.data)}
                    </ul>
                    <a className="arrowed-link color-1 barlow-font" href={window.location.origin + item.Link}>{supportData?.more_articles_link_text}<i className="icon-angle-right"></i></a>
                </div>
            ));
        }
    }
    const handleSupportArticle = (SupportArticles: any) => {
        if(SupportArticles){
            return Array.isArray(SupportArticles) && SupportArticles.map((item, index) => (
                <li className="mb-3" key={index}>
                    <a href={window.location.origin + "/support/" + item?.attributes?.slug}>{item?.attributes?.Name}</a>
                </li>
            ));
        }
    }

    const handleClick = (index: any) => {
        if (isMobile) {
            setActiveItemIndex(activeItemIndex === index ? null : index);
        }
      };

    const handleChange = (event: { target: { value: any; }; }) => {
        setKeyword(event.target.value);
        setIsSearch(true);
    };

    const handleDataFromChild = (data: any) => {
        setKeyword(data);
        setIsSearch(false);
    };

    const validateInput = () => {
        const input = document.querySelector('input[name="keyword"]');
        const value = input.value;
        const pattern = /<.*?>|javascript:|on\w+=/gi;
        if (pattern.test(value)) {
            input.value = '';
            return false;
        }
        return true;
    }
  
    if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }
    return (
      <>
        <RenderSnA seo={seo} ga={ga} />
            <section id="search" className="support spacer-top mb-5">
                <div className="container-fluid">
                    <input type="hidden" value="" name="lang" />
                    <h1 className="text-center mb-5 font-medium">{supportData?.search_title}</h1>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-sm-12">
                            <form className="input-group search-support main-support-search mx-auto position-relative" action="/support-search-result" autoComplete="off" onSubmit={validateInput}>
                                <input type="text" placeholder={supportData?.search_bar_placeholder} name="keyword" value={keyword} className="mb-0 form-control search-field" onChange={handleChange} />
                                <div className="input-group-append">
                                    <button type="submit" className="input-group-text">
                                        <i className="icon-search-icon lg_font_size mr-3 align-middle"></i>
                                        <span className="lg_font_size">{supportData?.search_bar_button_label}</span>
                                    </button>
                                </div>
                                <div className="suggestions">
                                    <SupportSearchSuggestion query={keyword} isSearch={isSearch} onData={handleDataFromChild} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section id="select-topic" className="support light-gray-bg py-5">
                <div className="container-fluid">
                    <h3 className="text-center mb-4 font-medium">{supportData?.topic_section_title}</h3>
                    <div className="row topic-row justify-content-center">
                        {handleTopic(supportData?.topics?.data)}
                    </div>
                </div>
            </section>
            <section id="common-solutions" className="support spacer">
                <div className="container-fluid">
                    <h3 className="text-center mb-4 font-medium">{supportData?.common_solutions_section_title}</h3>
                    <div className="row small-margin justify-content-center">
                        {handleCommonSolutionsWithImage(supportData?.posts_with_image?.data)}
                        {handleCommonSolutionsWithDiscription(supportData?.posts_with_descriptions?.data)}
                    </div>
                </div>
            </section>
            <section id="faq" className="support py-5 light-gray-bg">
                <div className="container-fluid">
                    <h3 className="text-center mb-4 font-medium">{supportData?.frequently_read_articles_section_title}</h3>
                    <div className="row justify-content-center">
                        {handleFaq(supportData?.freq_group)}
                    </div>
                </div>
            </section>
      </>
    );
};

export default Support;